var React = require('react');

function IconSearchInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"fill":"currentColor","d":"M20.56 18.43l-3.91-3.9-.07-.06a7.4 7.4 0 10-2.12 2.11l.06.07 3.91 3.9a1.5 1.5 0 002.13-2.12zm-10.16-3.2a4.83 4.83 0 110-9.66 4.83 4.83 0 010 9.67z","id":"icon_search_inline"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#icon_search_inline","transform":"translate(-3 -3)","key":1})]);
}

IconSearchInline.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = IconSearchInline;

IconSearchInline.default = IconSearchInline;
